/**
 * Update Responsive Values Utility
 *
 * Utility function for updating values for a specific breakpoint in responsive attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveAttributes, ResponsiveBreakpoint } from '../../types';

/**
 * Update values for a specific breakpoint in responsive attributes
 */
export const updateResponsiveValues = < T >(
	attributes: ResponsiveAttributes< T >,
	values: Partial< T >,
	breakpoint: ResponsiveBreakpoint,
): Partial< ResponsiveAttributes< T > > => {
	const currentValues = attributes[ breakpoint ] || ( {} as T );

	return {
		...attributes,
		[ breakpoint ]: {
			...currentValues,
			...values,
		},
	};
};
